import type { FC } from "react";
import React from "react";

import PrimeHooverBanner from "./versions/Default/PrimeHooverBanner";

interface PrimeHooverBannerContainerProps {
  pageCategoryName: string;
  isPrimeLoggedUser?: boolean;
  isOpen: boolean;
}

const PrimeHooverBannerContainer: FC<PrimeHooverBannerContainerProps> = ({
  pageCategoryName,
  isPrimeLoggedUser,
  isOpen,
}) => {
  return (
    <PrimeHooverBanner
      pageCategoryName={pageCategoryName}
      isPrimeLoggedUser={isPrimeLoggedUser}
      isOpen={isOpen}
    />
  );
};

export default PrimeHooverBannerContainer;
